import { Stack, StackProps, Typography } from '@mui/material';
import Image from 'next/image';

import { backgrounds } from '@/assets/materials';

import ShowMoreText from './ShowMoreText';

interface TeamCardProps extends StackProps {
  name: string;
  decs: string;
  image: string;
}

export const TeamCard = ({ name, decs, image }: TeamCardProps) => {
  return (
    <Stack width={'100%'} height={'100%'} position={'relative'}>
      <Stack
        position={'relative'}
        bgcolor={'#FFFFFF0D'}
        width={'100%'}
        minHeight={'600px'}
        paddingTop={{ xs: '174px', sm: '289px' }}
        sx={{
          clipPath: {
            xs: 'polygon(0% 0%, 100% 0, 100% 95%, 90% 100%, 0% 100%)',
            sm: 'polygon(0% 0%, 100% 0, 100% 90%, 93% 100%, 0% 100%)',
          },
        }}>
        <Stack
          top={'3px'}
          left={'3px'}
          width={'calc(100% - 6px)'}
          height={'calc(100% - 6px)'}
          position={'absolute'}
          bgcolor={'#060912'}
          sx={{
            clipPath: {
              xs: 'polygon(0% 0%, 100% 0, 100% 95%, 90% 100%, 0% 100%)',
              sm: 'polygon(0% 0%, 100% 0, 100% 90%, 93% 100%, 0% 100%)',
            },
          }}
        />

        <Stack
          position={'absolute'}
          top={'3px'}
          left={'3px'}
          right={'3px'}
          height={{ xs: '174px', sm: '289px' }}
          width={'calc(100% - 6px)'}
          bgcolor={'#00000080'}>
          <Image src={backgrounds.team_card_bg} alt={''} layout={'fill'} objectFit={'cover'} />
        </Stack>
        <Stack
          position={'absolute'}
          top={'3px'}
          left={'3px'}
          right={'3px'}
          height={{ xs: '174px', sm: '289px' }}
          width={'calc(100% - 6px)'}
          bgcolor={'#00000080'}
          zIndex={1}
        />

        <Stack gap={{ xs: 2, sm: 3 }} width={'100%'} padding={{ xs: '181px 24px 24px', sm: '44px 44px 44px 396px' }}>
          <Typography
            component={'h3'}
            zIndex={10}
            variant={'displayMedium'}
            className={'clip-text'}
            fontSize={{ xs: '20px', sm: '36px' }}
            lineHeight={{ xs: '24px', sm: '48px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            {name}
          </Typography>
          <ShowMoreText text={decs} />
        </Stack>
      </Stack>
      <Stack
        width={{ xs: '205px', sm: '400px' }}
        height={{ xs: '293px', sm: '570px' }}
        position={'absolute'}
        bottom={{ xs: 'unset', sm: '-23px' }}
        top={{ xs: '20px', sm: 'unset' }}
        left={'-23px'}
        zIndex={5}
        sx={{
          background: `url(${image})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
    </Stack>
  );
};
